module.exports = __webpack_public_path__ + "media/images/banner4-fa4a3ba869820608eb0608ede11a98af.jpg";